<template>
  <div>
    <div
      v-if="item.status === 'running'"
      style="position:relative;"
    >
      <v-progress-linear
        color="info"
        :height="height || '20'"
        :value="item.progress"
      />
      <span
        v-if="isFormDataReport && (item.progress == 50 || item.progress == 0)"
      >
        <span
          v-if="item.progress == 0"
          style="color:black;"
          class="progress_text"
        >
          Building Columns...
        </span>
        <span
          v-else-if="item.progress == 50"
          class="progress_text"
        >
          Building Answer Cache... ({{item.progress}}%)
        </span>
      </span>
      <span v-else class="progress_text">Building Report... ({{item.progress}}%)</span>
    </div>
    <div
      v-if="item.status === 'new'"
      style="position:relative;"
    >
      <v-progress-linear
        color="secondary"
        :height="height || '20'"
        value="100"
      />
      <span class="progress_text">Waiting in line...</span>
    </div>
    <div
      v-if="item.status === 'failed'"
      style="position:relative;"
    >
      <v-tooltip
        left
        color="error"
        max-width="300"
      >
        <div
          slot="activator"
        >
          <v-progress-linear
            color="red"
            :height="height || '20'"
            :value="item.progress"
            v-on="on"
          />
          <span
            class="progress_text"
            v-on="on"
          >
            Failed to build report...
          </span>
        </div>
        <span>{{item.error}}</span>
      </v-tooltip>
    </div>
    <div
      v-if="item.status === 'finished'"
      style="position:relative;"
      @click="$emit('download')"
    >
      <v-progress-linear
        color="green"
        :height="height || '20'"
        :value="item.progress"
      />
      <span class="progress_text">
        Click to Download
        <v-icon
          color="white"
          size="18"
          style="float:right;"
        >
          cloud_download
        </v-icon>
      </span>
    </div>
  </div>
</template>


<script>
import api from '@/api'
import moment from 'moment'

export default {
  name: 'ReportRow',
  props: [ 'item', 'height' ],
  computed: {
    isFormDataReport () {
      return this.item.type == "userform"
    }
  }
}
</script>
